/**
 * Active org units of a workspace, by display name (for assignee pickers and labels).
 */
import { useEffect, useState } from 'react';
import { getTypedSupabaseClient } from '@/lib/typedSupabaseClient';

export function useOrgUnitNames(workspaceId: string | null) {
  const [units, setUnits] = useState<{ id: string; name: string }[]>([]);
  useEffect(() => {
    if (!workspaceId) return;
    let cancelled = false;
    void getTypedSupabaseClient()
      .from('org_units')
      .select('id, display_name')
      .eq('workspace_id', workspaceId)
      .eq('active', true)
      .order('display_name')
      .then(({ data }) => {
        if (!cancelled) setUnits((data ?? []).map((u) => ({ id: u.id, name: u.display_name })));
      });
    return () => { cancelled = true; };
  }, [workspaceId]);
  return units;
}

